













import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class Tabs extends Vue {
  /**
   * tabsArr 循环数组
   * tabsActive 当前高亮项
   * direction 方向 left  center right 标签位置
   *
   */
  @Prop({ required: true }) tabsArr!: any[]
  @Prop({ required: true }) tabsActive!: number
  @Prop({ default: 'left' }) direction!: string
  handlClickTabs(idx:number, item:any) {
    this.$emit('on-handl-click-tabs', idx, item)
  }
}
